<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    width="17.494384765625"
    height="17.496091842651367"
    viewBox="0 0 17.494384765625 17.496091842651367"
  >
    <g>
      <path
        d="M1.50586,6.95703L1.50586,2.43945L6.02148,2.4375L6.02344,6.95508L1.50586,6.95703ZM6.02344,0.933594L1.50391,0.933594C0.673828,0.935547,0.0019531,1.60742,0,2.4375L0,6.95898C0.0019531,7.78906,0.673828,8.46094,1.50391,8.46289L6.02539,8.46289C6.85547,8.46094,7.52734,7.78906,7.5293,6.95898L7.5293,2.4375C7.52539,1.60742,6.85352,0.935547,6.02344,0.933594ZM1.50586,15.9902L1.50586,11.4707L6.02148,11.4688L6.02344,15.9863L1.50586,15.9902ZM6.02344,9.9668L1.50391,9.9668C0.673828,9.96875,0.0019531,10.6406,0,11.4707L0,15.9922C0.0019531,16.8223,0.673828,17.4941,1.50391,17.4961L6.02539,17.4961C6.85547,17.4941,7.52734,16.8223,7.5293,15.9922L7.5293,11.4687C7.52539,10.6406,6.85352,9.96875,6.02344,9.9668ZM12.7969,7.89258L9.60156,4.69727L12.793,1.50195L15.9902,4.69531L12.7969,7.89258ZM17.0547,3.63477L13.8574,0.439453C13.2695,-0.146484,12.3203,-0.146484,11.7324,0.439453L8.53711,3.63477C8.25575,3.91581,8.09766,4.29734,8.09766,4.69531C8.0957,5.0957,8.25391,5.47852,8.53711,5.76172L11.7344,8.95898C12.3223,9.54492,13.2734,9.54492,13.8594,8.95898L17.0566,5.76172C17.6406,5.17187,17.6406,4.2207,17.0547,3.63477ZM10.5371,15.9902L10.5371,11.4707L15.0527,11.4688L15.0547,15.9863L10.5371,15.9902ZM15.0566,9.9668L10.5352,9.9668C9.70508,9.96875,9.0332,10.6406,9.03125,11.4707L9.03125,15.9922C9.0332,16.8223,9.70508,17.4941,10.5352,17.4961L15.0566,17.4961C15.8867,17.4941,16.5586,16.8223,16.5605,15.9922L16.5605,11.4687C16.5586,10.6406,15.8848,9.96875,15.0566,9.9668Z"
        fill-opacity="1"
        style="mix-blend-mode:passthrough"
      />
    </g>
  </svg>
</template>
<script>
export default {
  data() {
    return {};
  },
  components: {},
  computed: {},
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
</style>
